enum SearchMode {
	editArtist = 'editArtist',
	analytic = 'analytic',
}

export default SearchMode;
